import { Container, Typography, Paper } from '@mui/material';

export const About = () => {
    return (
        <Container maxWidth="lg">
            <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ mb: 4 }}>
                About
            </Typography>
            <Paper elevation={2} sx={{ p: 4 }}>
                <Typography variant="body1" paragraph>
                    This is my hobby to teach and share knowledge in NLP and ML. I have created content, blogs, videos along with the code.
                </Typography>
                <Typography variant="body1" paragraph>
                    For few videos I have created Hindi and Telugu versions as well.
                </Typography>
                <Typography variant="body1">
                    For Contact details click on the bottom of the page.
                </Typography>
            </Paper>
        </Container>
    )
}